import React from 'react'
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import VideocamIcon from '@mui/icons-material/Videocam';
import MicIcon from '@mui/icons-material/Mic';
import {RTCVideo} from '@dmc/react-rtc-media-components';

function Settings(
    {
        container,
        videoEnabled,
        audioDevices,
        videoDevices,
        audioDeviceId,
        videoDeviceId,
        onAudioChange,
        onVideoChange,
        localVideoStream,
        screensharing
    }
) {

  const audioIcon = <MicIcon color='primary' sx={{m:2}}/> 
  const videoIcon = <VideocamIcon color='primary' sx={{m:2}}/> 

  const renderSelectInput = (icon, name, value, items, onChange) => {
    let component = 
    <div className='flex-select'>
        {icon}
        <FormControl fullWidth margin='normal'>
            <InputLabel id={'label-' + name}>{name}</InputLabel>
            <Select
                // id={input.id}
                sx={{width: '21rem'}}
                name={name}
                labelId={'label-' + name}
                label={name}
                value={value}
                onChange={(event) => onChange(event.target.value)}
                MenuProps={{ container: container, ModalProps: { container: container } }}
            >
                {items.map((item, i) => {
                    return <MenuItem key={name + '-item-' + i} value={item.deviceId}>{item.label}</MenuItem>
                })}
            </Select> 
        </FormControl>
    
    </div>
    return component
  }

  const renderLocalVideo = () => {
    return (
      <RTCVideo
        srcObject={localVideoStream}
        style={{
          maxWidth: "100%",
          height: "100%",
          borderRadius: "5px",
          objectFit: "contain",
          transform: screensharing ? "rotateY(0deg)" : "rotateY(180deg)",
          MozTransform: screensharing ? "rotateY(0deg)" : "rotateY(180deg)"
        }}
        autoPlay
        muted={true}
      />
    )
  }

  return (
    <div className='live-call-settings'>
        {videoEnabled ? renderLocalVideo() : null}
        {renderSelectInput(audioIcon, 'Audio', audioDeviceId, audioDevices, onAudioChange)}
        {videoEnabled ? renderSelectInput(videoIcon, 'Video', videoDeviceId, videoDevices, onVideoChange) : null}
    </div>
  )
}

export default Settings